import React, { useEffect, useRef, useState } from 'react';
import { T } from '../../traks';
import WaveSurfer from 'wavesurfer.js';
import "./styles.css"


const WhistleAudioContent = ({ audioContentURL }) => {
	const [playing, setPlaying] = useState(false)
	const [waveform, setWaveform] = useState(undefined)

	const waveformRef = useRef(null);

	const handlePlay = () => {
		console.log(waveform)
		setPlaying(!playing)
		waveform.playPause();
	};

	useEffect(() => {
		if (waveformRef.current !== undefined && waveform === undefined) {
			setWaveform(
				WaveSurfer.create({
					barWidth: 5,
					cursorWidth: 5,
					barHeight: 100,
					container: waveformRef.current,
					backend: 'WebAudio',
					height: 100,
					progressColor: "#266663",
					waveColor: "#FAFAFA",
					responsive: true,
					cursorColor: '#266663',
				})
			)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [waveformRef.current])

	useEffect(() => {
		if (waveform !== undefined)
			waveform.load(document.querySelector('#track'))
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [waveform])

	return (<>
		<div className="fs-3 mb-3"><T>Audio File</T></div>
		<div className="waveform-container py-4 px-4 sibilus_border d-flex align-items-center justify-content-center w-100 h-100 sborder_radius_6px">
			<div className="play-con bg_primary fw_600 me-4" onClick={handlePlay} >
				<span className="txt_white cursor_pointer">{!playing ? 'Play' : 'Pause'}</span>
			</div>
			<div className="w-100 h-100" ref={waveformRef} />
			<audio id="track" src={audioContentURL} />
		</div>
	</>);
};

export default WhistleAudioContent;
